import { default as arrangementenmSbDoFkNoXMeta } from "/home/tickets-r2ncy/tickets.dev2.on24.nl/client/pages/arrangementen.vue?macro=true";
import { default as donatieUkdNqeKqkBMeta } from "/home/tickets-r2ncy/tickets.dev2.on24.nl/client/pages/donatie.vue?macro=true";
import { default as gegevensBZzvCiqi0AMeta } from "/home/tickets-r2ncy/tickets.dev2.on24.nl/client/pages/gegevens.vue?macro=true";
import { default as indexCCHyjnspauMeta } from "/home/tickets-r2ncy/tickets.dev2.on24.nl/client/pages/index.vue?macro=true";
import { default as overzichtmDnoxPegnyMeta } from "/home/tickets-r2ncy/tickets.dev2.on24.nl/client/pages/overzicht.vue?macro=true";
import { default as plan_45je_45bezoekmK74zke7PfMeta } from "/home/tickets-r2ncy/tickets.dev2.on24.nl/client/pages/plan-je-bezoek.vue?macro=true";
import { default as ticketsJQbRSHRi3rMeta } from "/home/tickets-r2ncy/tickets.dev2.on24.nl/client/pages/tickets.vue?macro=true";
export default [
  {
    name: arrangementenmSbDoFkNoXMeta?.name ?? "arrangementen",
    path: arrangementenmSbDoFkNoXMeta?.path ?? "/arrangementen",
    meta: arrangementenmSbDoFkNoXMeta || {},
    alias: arrangementenmSbDoFkNoXMeta?.alias || [],
    redirect: arrangementenmSbDoFkNoXMeta?.redirect || undefined,
    component: () => import("/home/tickets-r2ncy/tickets.dev2.on24.nl/client/pages/arrangementen.vue").then(m => m.default || m)
  },
  {
    name: donatieUkdNqeKqkBMeta?.name ?? "donatie",
    path: donatieUkdNqeKqkBMeta?.path ?? "/donatie",
    meta: donatieUkdNqeKqkBMeta || {},
    alias: donatieUkdNqeKqkBMeta?.alias || [],
    redirect: donatieUkdNqeKqkBMeta?.redirect || undefined,
    component: () => import("/home/tickets-r2ncy/tickets.dev2.on24.nl/client/pages/donatie.vue").then(m => m.default || m)
  },
  {
    name: gegevensBZzvCiqi0AMeta?.name ?? "gegevens",
    path: gegevensBZzvCiqi0AMeta?.path ?? "/gegevens",
    meta: gegevensBZzvCiqi0AMeta || {},
    alias: gegevensBZzvCiqi0AMeta?.alias || [],
    redirect: gegevensBZzvCiqi0AMeta?.redirect || undefined,
    component: () => import("/home/tickets-r2ncy/tickets.dev2.on24.nl/client/pages/gegevens.vue").then(m => m.default || m)
  },
  {
    name: indexCCHyjnspauMeta?.name ?? "index",
    path: indexCCHyjnspauMeta?.path ?? "/",
    meta: indexCCHyjnspauMeta || {},
    alias: indexCCHyjnspauMeta?.alias || [],
    redirect: indexCCHyjnspauMeta?.redirect || undefined,
    component: () => import("/home/tickets-r2ncy/tickets.dev2.on24.nl/client/pages/index.vue").then(m => m.default || m)
  },
  {
    name: overzichtmDnoxPegnyMeta?.name ?? "overzicht",
    path: overzichtmDnoxPegnyMeta?.path ?? "/overzicht",
    meta: overzichtmDnoxPegnyMeta || {},
    alias: overzichtmDnoxPegnyMeta?.alias || [],
    redirect: overzichtmDnoxPegnyMeta?.redirect || undefined,
    component: () => import("/home/tickets-r2ncy/tickets.dev2.on24.nl/client/pages/overzicht.vue").then(m => m.default || m)
  },
  {
    name: plan_45je_45bezoekmK74zke7PfMeta?.name ?? "plan-je-bezoek",
    path: plan_45je_45bezoekmK74zke7PfMeta?.path ?? "/plan-je-bezoek",
    meta: plan_45je_45bezoekmK74zke7PfMeta || {},
    alias: plan_45je_45bezoekmK74zke7PfMeta?.alias || [],
    redirect: plan_45je_45bezoekmK74zke7PfMeta?.redirect || undefined,
    component: () => import("/home/tickets-r2ncy/tickets.dev2.on24.nl/client/pages/plan-je-bezoek.vue").then(m => m.default || m)
  },
  {
    name: ticketsJQbRSHRi3rMeta?.name ?? "tickets",
    path: ticketsJQbRSHRi3rMeta?.path ?? "/tickets",
    meta: ticketsJQbRSHRi3rMeta || {},
    alias: ticketsJQbRSHRi3rMeta?.alias || [],
    redirect: ticketsJQbRSHRi3rMeta?.redirect || undefined,
    component: () => import("/home/tickets-r2ncy/tickets.dev2.on24.nl/client/pages/tickets.vue").then(m => m.default || m)
  }
]